module.exports = __webpack_public_path__ + "img/plus-box-bg.ccdddfb3.svg";